import { ChevronsUpDown } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { sidebarMenuButtonVariants } from '@/components/ui/sidebar';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import useUserStore from '@/store/useUserStore';
import { cn, getInitials } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '@/config/react-query';
import httpClient from '@/api/httpClient';
import { paths } from '@/routes/paths';
import { useAnalytics } from '@/hooks/use-analytics';

const AccountSwitcher = () => {
  const { user } = useUserStore();

  const navigate = useNavigate();

  const { logout: logoutAnalytics } = useAnalytics();

  if (!user) {
    return null;
  }

  const { firstName, lastName, picture, email } = user;

  const handleLogout = () => {
    logoutAnalytics();

    navigate(paths.LOGIN);

    queryClient.clear();

    httpClient.logout();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger tabIndex={-1} asChild>
        <button
          data-sidebar="menu-button"
          className={cn(
            sidebarMenuButtonVariants({ variant: 'default', size: 'default' }),
            'flex justify-between items-center flex-row-reverse w-fit h-auto p-0 bg-background rounded-lg hover:bg-background focus:outline-none focus-visible:outline-none focus-visible:ring-0 lg:flex-row lg:w-full lg:p-3 lg:border lg:border-solid lg:border-border lg:drop-shadow-sm lg:hover:border-border',
          )}
        >
          <Avatar className="size-9 shrink-0">
            {picture ? <AvatarImage src={picture} /> : null}
            <AvatarFallback>{getInitials(firstName, lastName)}</AvatarFallback>
          </Avatar>
          <div className="flex flex-col gap-1 leading-none min-w-0 max-w-[160px]">
            <span className="font-normal leading-none text-foreground truncate">{`${firstName} ${lastName}`}</span>
            <span className="hidden text-xs font-light leading-none text-foreground truncate lg:block">
              {email}
            </span>
          </div>
          <ChevronsUpDown
            className="hidden ml-auto shrink-0 stroke-accent-foreground lg:block"
            size={16}
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[--radix-dropdown-menu-trigger-width]" align="start">
        <DropdownMenuItem className="cursor-pointer" onSelect={handleLogout}>
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export { AccountSwitcher };
